const state = {
  sidebar: {
    opened: true,
    withoutAnimation: false
  },
  device: 'desktop',
  activeTopMenu: null, // 必须初始化
  sideMenus: []       // 二级菜单存储
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
  },
  SET_ACTIVE_TOP_MENU(state, { menuId, rootState }) {
    const menuTree = rootState.user.menus.menus || []
    // 通过rootState访问其他模块
    const topMenu = menuTree.find(menu => menu.uid === menuId)
    state.sideMenus = topMenu?.children || []
    state.activeTopMenu = menuId;
    //console.log('----二级菜单----');
    //console.log(state.sideMenus );
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}